module.exports = __webpack_public_path__ + "img/nikola.8bbe04b9.png";